<template>
  <div class="table-area">
    <div class="table-a">
      <div class="table-name">
        <h3 class="ico_table_name">{{title}}</h3>
      </div>
      <table id="basic" class="table infotable">
        <tbody>
          <tr>
            <th>출고일자</th>
            <th>출고번호</th>
            <th>출고구분</th>
            <th>출고센터</th>
            <th>제조사</th>
            <th>제품군</th>
            <th>품번</th>
            <th>품명</th>
            <th>양품출고</th>
            <th>불량출고</th>
          </tr>
          <tr>
            <!--<td><input class="input" type="text" v-model="this.$moment(form.inDt).format('YYYY-MM-DD')" style="text-align:center;" disabled ></td>-->
            <td><input class="input" type="text" v-model="form.outDt" style="text-align:center;" disabled ></td>
            <td><input class="input" type="text" v-model="form.outItemId" style="text-align:center;" disabled ></td>
            <td><input class="input" type="text" v-model="form.outTypeNm" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.inAsAgentNm" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.makerNm" style="text-align:center;" disabled></td>
            <td><input class="input" type="text" v-model="form.itemGroupNm" disabled></td>
            <td><input class="input" type="text" v-model="form.itemCd" disabled></td>
            <td><input class="input" type="text" v-model="form.itemNm" disabled></td>
            <td><input class="input" type="text" v-model="form.inGoodQty" style="text-align:right;" id="inGoodQty"></td>
            <td><input class="input" type="text" v-model="form.badQty" style="text-align:right;" id="badQty"></td>
            <input class="input" type="hidden" v-model="form.groupUid">
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import mixin from '@/mixin/lucoms';

export default {
  name: "mateDeliveryInfo",
  mixins: [mixin],
  props: ['mateDeliveryDetail'],
  data() {
    return {
      title : "출고 수정",
      form: {
        companyCd : '',
        productType : 'Item',
        inItemId: '',
        outDt: '',
        outItemId : '',
        outType : '',
        inAsAgentNm : '',
        asAgentId : '',
        itemId : '',
        inGoodQty: '',
        recycleQty : 0,
        badQty : 0,
        outAgentId : 0,
        inTypeNm: '',
        makerNm: '',
        itemGroupNm: '',
        itemCd: '',
        itemNm: '',
        description : '',
        //outItemRequestId : '',
      },
    };
  },
  methods: {
    setMateDeliveryDetailInfo() {
      Object.assign(this.form, this.mateDeliveryDetail);
    },
    validation() {
      const mateDeliveryInfo = JSON.parse(JSON.stringify(this.form));
      const stripFields = ['inGoodQty'];
      _.forEach(stripFields, (name) => mateDeliveryInfo[name] = this.toPure(mateDeliveryInfo[name]));

      if (!mateDeliveryInfo.inGoodQty) {
        this.$swal({type: 'warning', text: '수량을 입력해 주세요.'});
        return false;
      }
      return true;
    },
    dataClear(){
      this.form.outDt = ''
      this.form.outItemId = ''
      this.form.outType = ''
      this.form.inAsAgentNm = ''
      this.form.makerNm = ''
      this.form.itemGroupNm = ''
      this.form.itemCd = ''
      this.form.itemNm = ''
      this.form.inGoodQty = ''
      this.form.badQty = ''
    }
  },
  watch: {
    mateDeliveryDetail() {
      this.setMateDeliveryDetailInfo();

      if(this.form.outType === 'Order'|| this.form.inDt !== null){
        document.getElementById("inGoodQty").disabled = true;
        document.getElementById("badQty").disabled = true;
        this.$parent.updateButtonShow = false;
      } else {
        document.getElementById("inGoodQty").disabled = false;
        document.getElementById("badQty").disabled = false;
        this.$parent.updateButtonShow = true;
      }

      if(this.form.outType !== 'Erp'){
        document.getElementById("badQty").disabled = true;
      }
    },
    'form.outDt':{
      immediate: true,
      deep: true,
      handler(value) {
        if( value !== ''){
          this.form.outDt = this.$moment(value).format('YYYY-MM-DD');
        }
      }
    }
  }
}
</script>

<style scoped>
</style>